import { render, staticRenderFns } from "./AluminumColorSection.vue?vue&type=template&id=03129f46&scoped=true&"
import script from "./AluminumColorSection.vue?vue&type=script&lang=js&"
export * from "./AluminumColorSection.vue?vue&type=script&lang=js&"
import style0 from "./AluminumColorSection.vue?vue&type=style&index=0&id=03129f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03129f46",
  null
  
)

export default component.exports